import { createRoute } from "@tanstack/react-router";
import { registerFeature } from "../registry";
import { DesksPage } from "./DesksPage";

registerFeature({
  routes: (appRoute) => [createRoute({ getParentRoute: () => appRoute, path: "/orgs/$org/desks", component: DesksPage })],
});
